<template>
  <div class="g-sidenav-show" style="background-color: #f0f6ff;">
    <div class="min-height-300 bg-dark position-absolute w-100"></div>
    <main class="main-content position-relative border-radius-lg ">
      <!-- Navbar -->
      <HeaderMenu></HeaderMenu>
      <!-- End Navbar -->
      <div class="container-fluid pt-6" style="min-height: 100vh;">
        <div v-for="(notification, index) in notifications" :key="index" class="alert position-fixed top-0 end-0 m-3"
          :class="notification.class" role="alert" style="color: white; z-index: 9999; max-width: 360px;">
          {{ notification.message }}
          <button style="font-size: small" type="button" class="btn-close" @click="closeNotification(index)"
            aria-label="Close"></button>
        </div>

        <div class="row">
          <div class="col-lg-8">
            <div class="card mb-4">
              <div class="card-header pb-0 d-flex align-items-center justify-content-between mb-2">
                <h3 class="mb-0">Buscador Global de Documentos</h3>
              </div>
              <div class="card-body px-0 pt-0 pb-2">
                <!-- Formulario de búsqueda -->
                <div class="p-3 border-bottom">
                  <div class="row g-3 align-items-center">
                    <div class="col-md-4">
                      <select class="form-select" v-model="metadatoSeleccionado" @change="onMetadatoChange">
                        <option :value="null">Selecciona un metadato</option>
                        <option v-for="metadato in metadatosDisponibles" :key="metadato.key" :value="metadato">
                          {{ metadato.label }}
                        </option>
                      </select>
                    </div>
                    <div class="col-md-6">
                      <template v-if="metadatoSeleccionado">
                        <!-- Selector de operador y valor -->
                        <div class="filter-input-group">
                          <template v-if="operadorActual?.operator === '□' || operadorActual?.operator === '▦'">
                            <div class="filter-empty w-100">
                              {{ operadorActual?.operator === '□' ? 'Vacio' : 'No vacio' }}
                            </div>
                          </template>
                          <template v-else-if="operadorActual?.operator === '<>'">
                            <input type="text" class="filter-value-with-selector"
                              v-model="valorBusqueda"
                              :placeholder="metadatoSeleccionado.tipo === 'date' ? 'ddmmyy;ddmmyy' : 'mín;máx'"
                              @keyup.enter="añadirFiltro">
                          </template>
                          <template v-else-if="operadorActual?.operator === '≡'">
                            <input type="text" class="filter-value-with-selector"
                              v-model="valorBusqueda" placeholder="valor1;valor2;valor3"
                              @keyup.enter="añadirFiltro">
                          </template>
                          <template v-else-if="metadatoSeleccionado.tipo === 'list'">
                            <select class="form-select" v-model="valorBusqueda" style="border-radius: 0.25rem 0 0 0.25rem; border-right: none;">
                              <option value="">Selecciona un valor</option>
                              <option v-for="valor in valoresLista" :key="valor.id" :value="valor.descripcion">
                                {{ valor.descripcion }}
                              </option>
                            </select>
                          </template>
                          <template v-else-if="metadatoSeleccionado.tipo === 'date'">
                            <input type="text" class="filter-value-with-selector"
                              v-model="valorBusqueda" placeholder="ddmmyy"
                              @keyup.enter="añadirFiltro">
                          </template>
                          <template v-else>
                            <input type="text" class="filter-value-with-selector"
                              v-model="valorBusqueda" 
                              :placeholder="getPlaceholder(metadatoSeleccionado.tipo)"
                              @keyup.enter="añadirFiltro">
                          </template>
                          <!-- Selector de operador -->
                          <div class="filter-operator-wrapper">
                            <div class="filter-operator-dropdown"
                              :class="{ 'show': showOperatorDropdown }"
                              @click="toggleOperatorDropdown">
                              <span class="filter-operator-display">
                                {{ getOperatorDisplay(operadorActual) }}
                              </span>
                              <i class="fas fa-chevron-down filter-operator-arrow"></i>
                            </div>
                            <div class="filter-operator-menu" v-show="showOperatorDropdown" @click.stop>
                              <div class="filter-operator-option"
                                v-for="op in operadoresDisponibles" :key="op.id"
                                :class="{ 'active': operadorActual?.id === op.id }"
                                @click="selectOperator(op)">
                                <span class="operator-label">{{ op.label }}</span>
                                <span class="operator-symbol">{{ op.operator }}</span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </template>
                      <input v-else type="text" class="form-control" v-model="valorBusqueda" 
                        placeholder="Selecciona un metadato primero" disabled>
                    </div>
                    <div class="col-md-2">
                      <button class="btn btn-primary w-100 mb-0" @click="añadirFiltro" 
                        :disabled="!metadatoSeleccionado || (!valorBusqueda && operadorActual?.operator !== '□' && operadorActual?.operator !== '▦') || cargando">
                        <span v-if="cargando" class="spinner-border spinner-border-sm me-2" role="status"></span>
                        Añadir
                      </button>
                    </div>
                  </div>
                  <!-- Filtro de caducidad (solo si la feature está disponible) -->
                  <div v-if="features.caducidad_documentos_disponible" class="mt-3">
                    <div class="row g-2 align-items-center">
                      <div class="col-md-3">
                        <label class="form-label small mb-1">Filtro de caducidad:</label>
                        <select class="form-select form-select-sm" v-model="filtroCaducidad" @change="aplicarFiltroCaducidad">
                          <option value="ninguno">Sin filtro de caducidad</option>
                          <option value="caducados">Documentos caducados</option>
                          <option value="proximos">Próximos a caducar</option>
                        </select>
                      </div>
                      <div v-if="filtroCaducidad === 'proximos'" class="col-md-3">
                        <label class="form-label small mb-1">Días:</label>
                        <input type="number" class="form-control form-control-sm" v-model.number="diasCaducidad" 
                          min="1" @change="aplicarFiltroCaducidad" placeholder="30">
                      </div>
                    </div>
                  </div>
                  <!-- Filtros activos -->
                  <div v-if="filtrosActivos.length > 0" class="mt-3">
                    <div class="d-flex flex-wrap align-items-center gap-2">
                      <span class="text-muted small d-flex align-items-center">Filtros activos:</span>
                      <span v-for="(filtro, index) in filtrosActivos" :key="index" 
                        class="badge bg-primary d-flex align-items-center gap-1">
                        <span>{{ getMetadatoLabel(filtro.campo) }} {{ getOperatorDisplay(filtro.operador) }} {{ filtro.valor || (filtro.operador.operator === '□' ? 'Vacio' : 'No vacio') }}</span>
                        <button class="btn-close btn-close-white" style="font-size: 0.6rem;" 
                          @click="eliminarFiltro(index)" title="Eliminar filtro"></button>
                      </span>
                      <button class="btn btn-sm btn-outline-secondary d-flex align-items-center mb-0" @click="limpiarFiltros">
                        <i class="fas fa-times me-1"></i> Limpiar todos
                      </button>
                    </div>
                  </div>
                  <div v-if="resultados.length > 0" class="mt-2">
                    <span class="text-muted small">Resultados: {{ totalResultados }}</span>
                  </div>
                </div>

                <!-- Tabla de resultados -->
                <div v-if="cargando" class="text-center my-5">
                  <div class="spinner-border text-primary" role="status">
                    <span class="visually-hidden">Cargando...</span>
                  </div>
                </div>
                <div v-else-if="resultados.length > 0" class="table-responsive px-3">
                  <table class="table table-striped table-bordered table-sm" style="font-size: 0.85rem;">
                    <thead>
                      <tr>
                        <th style="min-width: 150px; font-weight: 600;">Esquema</th>
                        <th v-if="features.caducidad_documentos_disponible && (filtroCaducidad !== 'ninguno' || resultados.some(r => r.fecha_caducidad || r.dias_restantes !== undefined))" 
                          style="min-width: 120px; font-weight: 600;">Caducidad</th>
                        <th v-for="columna in columnasCombinadas" :key="columna.key" 
                          style="min-width: 140px; max-width: 300px; font-weight: 600;">
                          {{ columna.label }}
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(resultado, index) in resultados" :key="`${resultado.id}_${resultado.esquema_id}_${index}`"
                        @click="seleccionarRegistro(resultado)"
                        :class="{ 'row-selected': registroSeleccionado.value?.id === resultado.id && registroSeleccionado.value?.esquema_id === resultado.esquema_id }">
                        <td>
                          <span class="badge" :style="{ backgroundColor: getEsquemaColor(resultado.esquema_id) }">
                            {{ getEsquemaNombre(resultado.esquema_id) }}
                          </span>
                        </td>
                        <td v-if="features.caducidad_documentos_disponible && (filtroCaducidad !== 'ninguno' || resultados.some(r => r.fecha_caducidad || r.dias_restantes !== undefined))">
                          <div v-if="resultado.fecha_caducidad">
                            <div class="small">{{ formatDate(resultado.fecha_caducidad) }}</div>
                            <div v-if="resultado.dias_restantes !== undefined && resultado.dias_restantes !== null">
                              <span v-if="resultado.dias_restantes < 0" class="badge bg-danger">
                                Caducado hace {{ Math.abs(resultado.dias_restantes) }} días
                              </span>
                              <span v-else-if="resultado.dias_restantes === 0" class="badge bg-warning">
                                Caduca hoy
                              </span>
                              <span v-else-if="resultado.dias_restantes <= 7" class="badge bg-warning">
                                {{ resultado.dias_restantes }} días restantes
                              </span>
                              <span v-else class="badge bg-success">
                                {{ resultado.dias_restantes }} días restantes
                              </span>
                            </div>
                          </div>
                          <span v-else class="text-muted small">-</span>
                        </td>
                        <td v-for="columna in columnasCombinadas" :key="columna.key"
                          class="table-cell-truncated" :title="getCellValue(resultado, columna)">
                          {{ formatCellValue(resultado, columna) }}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <div v-else-if="haBuscado && !cargando && resultados.length === 0" class="text-center my-5 text-muted">
                  <p>No se encontraron resultados con los filtros aplicados</p>
                </div>
                <div v-else class="text-center my-5 text-muted">
                  <p>Selecciona un metadato y un valor para buscar</p>
                </div>

                <!-- Paginación -->
                <div v-if="resultados.length > 0 && totalPaginas > 1" 
                  class="table-footer d-flex justify-content-center align-items-center px-3 py-2">
                  <div class="d-flex gap-2 align-items-center">
                    <button class="btn btn-sm btn-outline-secondary" @click="cambiarPagina(paginaActual - 1)"
                      :disabled="paginaActual === 1 || cargando">
                      <i class="fas fa-arrow-left"></i>
                    </button>
                    <span class="text-muted small">Página {{ paginaActual }} de {{ totalPaginas }}</span>
                    <button class="btn btn-sm btn-outline-secondary" @click="cambiarPagina(paginaActual + 1)"
                      :disabled="paginaActual === totalPaginas || cargando">
                      <i class="fas fa-arrow-right"></i>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-lg-4">
            <!-- Panel de Detalle del Documento -->
            <DetalleDocumento 
              v-if="registroSeleccionado.value && esquemaSeleccionado"
              :esquema="esquemaSeleccionado" 
              :registro-seleccionado="registroSeleccionado"
              :listas-disponibles="listasDisponibles" 
              :show-notification="showNotification" 
              :id="registroSeleccionado.value?.esquema_id"
              @guardar-registro="guardarRegistro" 
              @eliminar-registro="confirmarEliminar"
              @actualizar-registro="actualizarRegistro" />
          </div>
        </div>
      </div>
    </main>
  </div>
</template>

<script>
import HeaderMenu from "../components/HeaderMenu.vue";
import DetalleDocumento from "../components/DetalleDocumento.vue";
import { computed, onMounted, reactive, ref, watch, nextTick } from "vue";
import axiosInstance from "@/axios";

export default {
  name: "BuscadorView",
  components: { HeaderMenu, DetalleDocumento },
  setup() {
    const notifications = ref([]);
    const esquemas = ref([]);
    const features = ref({
      caducidad_documentos_disponible: false
    });
    const metadatosDisponibles = ref([]);
    const metadatoSeleccionado = ref(null);
    const valorBusqueda = ref('');
    const resultados = ref([]);
    const registroSeleccionado = reactive({});
    const esquemaSeleccionado = ref(null);
    const listasDisponibles = ref([]);
    // Cache para valores de listas (listaId -> valores[])
    const valoresListasCache = ref({});
    const valoresListasPending = ref({});
    const cargando = ref(false);
    const haBuscado = ref(false);
    const paginaActual = ref(1);
    const totalResultados = ref(0);
    const pageLength = ref(20);
    const filtrosActivos = ref([]); // Filtros acumulados
    const operadorActual = ref(null);
    const showOperatorDropdown = ref(false);
    // Filtro de caducidad
    const filtroCaducidad = ref('ninguno'); // 'ninguno', 'caducados', 'proximos'
    const diasCaducidad = ref(30);

    // Configuración de operadores de filtro (igual que TableView)
    const filters_operator = [
      { id: 1, label: 'Igual', operator: '=' },
      { id: 2, label: 'Mayor/igual', operator: '>=' },
      { id: 3, label: 'Menor/igual', operator: '<=' },
      { id: 4, label: 'Mayor', operator: '>' },
      { id: 5, label: 'Menor', operator: '<' },
      { id: 6, label: 'Contiene', operator: '@' },
      { id: 7, label: 'Empieza', operator: '[' },
      { id: 8, label: 'Termina', operator: ']' },
      { id: 9, label: 'Entre', operator: '<>' },
      { id: 10, label: 'Diferente', operator: '!=' },
      { id: 11, label: 'No contiene', operator: '!@' },
      { id: 13, label: 'Vacio', operator: '□' },
      { id: 14, label: 'No vacio', operator: '▦' },
      { id: 15, label: 'Listado', operator: '≡' }
    ];

    const filters_comparador_text = [1, 6, 7, 8, 10, 11, 13, 14, 15];
    const filters_comparador_number = [1, 2, 3, 4, 5, 9, 10, 13, 14, 15];
    const filters_comparador_datepicker = [1, 2, 3, 4, 5, 9, 10, 13, 14, 15];

    // Función para cerrar una notificación
    const closeNotification = (index) => {
      notifications.value.splice(index, 1);
    };

    const showNotification = (message, type) => {
      const notification = {
        message,
        class: type,
      };
      notifications.value.push(notification);
      setTimeout(() => {
        closeNotification(notifications.value.indexOf(notification));
      }, 2000);
    };

    // Cargar esquemas y metadatos
    const cargarEsquemas = async () => {
      try {
        const response = await axiosInstance.get("/api/esquemas");
        esquemas.value = response.data.esquemas || [];
        
        // Cargar features
        if (response.data.features) {
          features.value = {
            caducidad_documentos_disponible: response.data.features.caducidad_documentos_disponible ?? false
          };
        }
        
        // Construir lista de metadatos únicos
        const metadatosMap = new Map();
        esquemas.value.forEach(esquema => {
          if (esquema.propiedades && Array.isArray(esquema.propiedades)) {
            esquema.propiedades.forEach(prop => {
              const key = `${prop.campoBD}_${prop.tipo}`;
              if (!metadatosMap.has(key)) {
                metadatosMap.set(key, {
                  key: prop.campoBD,
                  label: prop.nombre || prop.campoBD,
                  tipo: prop.tipo,
                  lista_id: prop.lista_id,
                  esquemas: []
                });
              }
              const metadato = metadatosMap.get(key);
              if (!metadato.esquemas.find(e => e.id === esquema.id)) {
                metadato.esquemas.push(esquema);
              }
            });
          }
        });
        // Convertir a array y ordenar alfabéticamente por label
        metadatosDisponibles.value = Array.from(metadatosMap.values()).sort((a, b) => {
          return a.label.localeCompare(b.label, 'es', { sensitivity: 'base' });
        });
      } catch (error) {
        console.error("Error al cargar esquemas", error);
        showNotification("Error al cargar esquemas", 'alert-danger');
      }
    };

    // Cargar listas disponibles
    const cargarListas = async () => {
      try {
        const response = await axiosInstance.get("/api/listas");
        listasDisponibles.value = response.data.data || [];
      } catch (error) {
        console.error("Error al cargar listas", error);
      }
    };

    // Función para cargar valores de una lista (una sola petición por lista_id)
    const cargarValoresLista = async (listaId) => {
      if (!listaId || valoresListasCache.value[listaId]) return;
      if (valoresListasPending.value[listaId]) return valoresListasPending.value[listaId];

      const promise = (async () => {
        try {
          const response = await axiosInstance.get(`/api/listas/${listaId}/valores`);
          const valores = response.data.data?.lista?.valores ?? response.data.lista?.valores ?? [];
          valoresListasCache.value[listaId] = valores;
          return valores;
        } catch (error) {
          console.error(`Error al obtener valores de la lista ${listaId}:`, error);
          valoresListasCache.value[listaId] = [];
          return [];
        } finally {
          delete valoresListasPending.value[listaId];
        }
      })();
      valoresListasPending.value[listaId] = promise;
      return promise;
    };

    // Valores de lista para el metadato seleccionado (reactivo)
    const valoresLista = computed(() => {
      if (!metadatoSeleccionado.value || !metadatoSeleccionado.value.lista_id) return [];
      const listaId = metadatoSeleccionado.value.lista_id;
      
      // Si no están en cache, iniciar carga asíncrona
      if (!valoresListasCache.value[listaId]) {
        cargarValoresLista(listaId);
        return []; // Retornar vacío mientras carga
      }
      
      return valoresListasCache.value[listaId] || [];
    });

    // Columnas combinadas de todos los esquemas
    const columnasCombinadas = computed(() => {
      if (resultados.value.length === 0) return [];
      
      const columnasMap = new Map();
      
      // Recorrer todos los resultados y recopilar todas las propiedades
      resultados.value.forEach(resultado => {
        const esquema = esquemas.value.find(e => e.id === resultado.esquema_id);
        if (esquema && esquema.propiedades) {
          esquema.propiedades.forEach(prop => {
            const key = prop.campoBD;
            if (!columnasMap.has(key)) {
              columnasMap.set(key, {
                key: prop.campoBD,
                label: prop.nombre || prop.campoBD,
                tipo: prop.tipo
              });
            }
          });
        }
      });
      
      return Array.from(columnasMap.values());
    });

    // Función para obtener operadores disponibles según el tipo
    const getAvailableOperators = (tipo) => {
      let operatorIds = [];
      switch (tipo) {
        case 'text':
        case 'longtext':
          operatorIds = filters_comparador_text;
          break;
        case 'int':
        case 'integer':
        case 'decimal':
        case 'decimal2':
        case 'decimal4':
          operatorIds = filters_comparador_number;
          break;
        case 'date':
          operatorIds = filters_comparador_datepicker;
          break;
        case 'list':
          operatorIds = [1, 10, 13, 14, 15];
          break;
        default:
          operatorIds = filters_comparador_text;
      }
      return filters_operator.filter(op => operatorIds.includes(op.id));
    };

    // Operadores disponibles para el metadato seleccionado
    const operadoresDisponibles = computed(() => {
      if (!metadatoSeleccionado.value) return [];
      return getAvailableOperators(metadatoSeleccionado.value.tipo);
    });

    // Inicializar operador por defecto cuando cambia el metadato
    watch(metadatoSeleccionado, (nuevoMetadato) => {
      if (nuevoMetadato) {
        const operators = getAvailableOperators(nuevoMetadato.tipo);
        if (['int', 'integer', 'decimal', 'decimal2', 'decimal4', 'date'].includes(nuevoMetadato.tipo)) {
          operadorActual.value = operators.find(op => op.operator === '=') || operators[0];
        } else {
          operadorActual.value = operators.find(op => op.operator === '@') || operators[0];
        }
      } else {
        operadorActual.value = null;
      }
    });

    // Función para obtener el display del operador
    const getOperatorDisplay = (operator) => {
      if (!operator) return '';
      return operator.operator || '';
    };

    // Toggle dropdown de operadores
    const toggleOperatorDropdown = () => {
      showOperatorDropdown.value = !showOperatorDropdown.value;
    };

    // Seleccionar operador
    const selectOperator = (operator) => {
      operadorActual.value = operator;
      showOperatorDropdown.value = false;
    };

    // Función para obtener el placeholder según el tipo
    const getPlaceholder = (tipo) => {
      switch(tipo) {
        case 'text': return 'Texto';
        case 'int': return 'Número entero';
        case 'decimal': return 'Número decimal';
        default: return 'Valor';
      }
    };

    // Obtener label del metadato
    const getMetadatoLabel = (campoBD) => {
      const metadato = metadatosDisponibles.value.find(m => m.key === campoBD);
      return metadato ? metadato.label : campoBD;
    };

    // Añadir filtro a la lista de filtros activos
    const añadirFiltro = () => {
      if (!metadatoSeleccionado.value || !operadorActual.value) return;
      
      // Validar que tenga valor si no es vacío/no vacío
      if (operadorActual.value.operator !== '□' && operadorActual.value.operator !== '▦' && !valorBusqueda.value) {
        return;
      }

      // Verificar si el filtro ya existe
      const filtroExistente = filtrosActivos.value.find(
        f => f.campo === metadatoSeleccionado.value.key && 
             f.operador.id === operadorActual.value.id &&
             f.valor === valorBusqueda.value
      );

      if (filtroExistente) {
        showNotification('Este filtro ya está activo', 'alert-info');
        return;
      }

      // Añadir el filtro
      filtrosActivos.value.push({
        campo: metadatoSeleccionado.value.key,
        tipo: metadatoSeleccionado.value.tipo,
        operador: operadorActual.value,
        valor: valorBusqueda.value || ''
      });

      // Limpiar el formulario
      valorBusqueda.value = '';
      
      // Buscar con todos los filtros
      buscar();
    };

    // Eliminar un filtro específico
    const eliminarFiltro = (index) => {
      filtrosActivos.value.splice(index, 1);
      paginaActual.value = 1;
      buscar();
    };

    // Aplicar filtro de caducidad
    const aplicarFiltroCaducidad = () => {
      paginaActual.value = 1;
      buscar();
    };

    // Quitar filtro de caducidad
    const quitarFiltroCaducidad = () => {
      filtroCaducidad.value = 'ninguno';
      diasCaducidad.value = 30;
      paginaActual.value = 1;
      buscar();
    };

    // Limpiar todos los filtros
    const limpiarFiltros = () => {
      filtrosActivos.value = [];
      filtroCaducidad.value = 'ninguno';
      diasCaducidad.value = 30;
      metadatoSeleccionado.value = null;
      valorBusqueda.value = '';
      resultados.value = [];
      totalResultados.value = 0;
      registroSeleccionado.value = {};
      esquemaSeleccionado.value = null;
      haBuscado.value = false;
      paginaActual.value = 1;
    };

    // Función para buscar documentos con todos los filtros acumulados
    const buscar = async () => {
      // Si no hay filtros activos ni filtro de caducidad, no buscar
      if (filtrosActivos.value.length === 0 && filtroCaducidad.value === 'ninguno') {
        resultados.value = [];
        totalResultados.value = 0;
        haBuscado.value = false;
        return;
      }
      
      cargando.value = true;
      haBuscado.value = true;
      
      try {
        const params = {
          page: paginaActual.value,
          per_page: pageLength.value
        };

        // Añadir filtros normales si existen
        if (filtrosActivos.value.length > 0) {
          params.filtros = filtrosActivos.value.map(filtro => ({
            campo: filtro.campo,
            tipo: filtro.tipo,
            operador: filtro.operador.operator,
            valor: filtro.valor
          }));
        }

        // Añadir filtro de caducidad si está activo
        if (filtroCaducidad.value === 'caducados') {
          params.dias_caducidad = -1; //documentos ya caducados
        } else if (filtroCaducidad.value === 'proximos') {
          params.dias_caducidad = diasCaducidad.value || 30;
        }
        
        const response = await axiosInstance.post("/api/buscarGlobal", { params });
        resultados.value = response.data.data || [];
        totalResultados.value = response.data.total || 0;
      } catch (error) {
        console.error("Error al buscar", error);
        showNotification("Error al buscar documentos", 'alert-danger');
        resultados.value = [];
        totalResultados.value = 0;
      } finally {
        cargando.value = false;
      }
    };

    // Cambiar página (paginación en backend)
    const cambiarPagina = async (pagina) => {
      if (pagina < 1 || pagina > totalPaginas.value) return;
      paginaActual.value = pagina;
      await buscar();
    };

    // Total de páginas (basado en total del backend)
    const totalPaginas = computed(() => {
      return Math.ceil(totalResultados.value / pageLength.value);
    });


    // Cuando cambia el metadato seleccionado
    const onMetadatoChange = () => {
      valorBusqueda.value = '';
      showOperatorDropdown.value = false;
    };

    // Seleccionar registro
    const seleccionarRegistro = async (resultado) => {
      // Buscar el esquema correspondiente primero
      let esquema = esquemas.value.find(e => e.id === resultado.esquema_id);
      
      // Si no encontramos el esquema, cargarlo
      if (!esquema) {
        try {
          const response = await axiosInstance.get(`/api/datosesquema/${resultado.esquema_id}`);
          esquema = response.data.esquema;
          // Añadir el esquema a la lista si no estaba
          if (!esquemas.value.find(e => e.id === esquema.id)) {
            esquemas.value.push(esquema);
          }
        } catch (error) {
          console.error("Error al cargar el esquema", error);
          showNotification("Error al cargar el esquema del documento", 'alert-danger');
          return;
        }
      }
      
      // Asignar el esquema primero
      esquemaSeleccionado.value = esquema;
      
      // Luego asignar el registro (esto disparará el watch en DetalleDocumento)
      await nextTick();
      Object.assign(registroSeleccionado, { value: resultado });
    };


    // Obtener nombre del esquema
    const getEsquemaNombre = (esquemaId) => {
      const esquema = esquemas.value.find(e => e.id === esquemaId);
      return esquema ? esquema.nombre : `Esquema ${esquemaId}`;
    };

    // Obtener color del esquema
    const getEsquemaColor = (esquemaId) => {
      const esquema = esquemas.value.find(e => e.id === esquemaId);
      return esquema?.color || '#6c757d';
    };

    // Formatear valor de celda
    const formatCellValue = (resultado, columna) => {
      const valor = resultado[columna.key];
      if (valor === null || valor === undefined) return '-';
      
      switch(columna.tipo) {
        case 'date':
          return formatDate(valor);
        case 'decimal':
        case 'decimal2':
          return parseFloat(valor).toFixed(2);
        case 'decimal4':
          return parseFloat(valor).toFixed(4);
        case 'int':
          return parseInt(valor);
        default:
          return valor;
      }
    };

    // Obtener valor de celda para tooltip
    const getCellValue = (resultado, columna) => {
      return formatCellValue(resultado, columna);
    };

    // Formatear fecha
    const formatDate = (value) => {
      if (!value) return '';
      const d = new Date(value);
      return ("0" + d.getDate()).slice(-2) + "/" + ("0" + (d.getMonth() + 1)).slice(-2) + "/" + d.getFullYear();
    };

    // Guardar registro
    const guardarRegistro = async (registro) => {
      try {
        const esquemaId = registro.esquema_id || registroSeleccionado.value?.esquema_id;
        const response = await axiosInstance.post(`/api/registroesquema/${esquemaId}`, { registro });
        Object.assign(registroSeleccionado, { value: response.data.registro });
        showNotification('Documento guardado.', 'alert-success');
        // Refrescar búsqueda
        await buscar();
      } catch (error) {
        showNotification("Error al guardar el documento", 'alert-danger');
      }
    };

    // Confirmar eliminar
    const confirmarEliminar = async (registro) => {
      try {
        const esquemaId = registro.esquema_id || registroSeleccionado.value?.esquema_id;
        await axiosInstance.post(`/api/borrarregistro/${esquemaId}`, { registro });
        showNotification('Registro eliminado.', 'alert-success');
        Object.assign(registroSeleccionado, { value: {} });
        esquemaSeleccionado.value = null;
        // Refrescar búsqueda
        await buscar();
      } catch (error) {
        showNotification('Error al eliminar el registro.', 'alert-danger');
      }
    };

    // Actualizar registro
    const actualizarRegistro = (registro) => {
      Object.assign(registroSeleccionado, { value: registro });
    };

    onMounted(() => {
      cargarEsquemas();
      cargarListas();

      // Cerrar dropdown al hacer clic fuera
      document.addEventListener('click', (event) => {
        if (!event.target.closest('.filter-operator-wrapper')) {
          showOperatorDropdown.value = false;
        }
      });
    });

    return {
      notifications,
      closeNotification,
      showNotification,
      metadatosDisponibles,
      metadatoSeleccionado,
      valorBusqueda,
      valoresLista,
      resultados,
      registroSeleccionado,
      esquemaSeleccionado,
      listasDisponibles,
      cargando,
      haBuscado,
      paginaActual,
      totalResultados,
      totalPaginas,
      filtrosActivos,
      operadorActual,
      operadoresDisponibles,
      showOperatorDropdown,
      columnasCombinadas,
      features,
      filtroCaducidad,
      diasCaducidad,
      aplicarFiltroCaducidad,
      quitarFiltroCaducidad,
      getPlaceholder,
      getMetadatoLabel,
      getOperatorDisplay,
      toggleOperatorDropdown,
      selectOperator,
      añadirFiltro,
      eliminarFiltro,
      limpiarFiltros,
      buscar,
      cambiarPagina,
      onMetadatoChange,
      seleccionarRegistro,
      getEsquemaNombre,
      getEsquemaColor,
      formatCellValue,
      getCellValue,
      formatDate,
      guardarRegistro,
      confirmarEliminar,
      actualizarRegistro
    };
  },
}
</script>

<style scoped>
.row-selected {
  background-color: #e7f3ff !important;
  border-left: 4px solid #0d6efd !important;
}

.row-selected:hover {
  background-color: #d0e7ff !important;
}

.table-cell-truncated {
  max-width: 300px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.table-cell-truncated:hover {
  background-color: #f8f9fa;
}

.table-footer {
  background-color: #f8f9fa;
  border-top: 1px solid #dee2e6;
  margin-top: 0;
}

/* Estilos para filtros avanzados (igual que TableView) */
.filter-input-group {
  display: flex;
  gap: 0;
  align-items: stretch;
  width: 100%;
  max-width: 100%;
  box-sizing: border-box;
}

.filter-value-with-selector {
  flex: 1;
  min-width: 0;
  max-width: 100%;
  font-size: 0.875rem;
  padding: 0.375rem 0.75rem;
  border: 1px solid #dee2e6;
  border-radius: 0.25rem 0 0 0.25rem;
  border-right: none;
  box-sizing: border-box;
}

.filter-operator-wrapper {
  position: relative;
  display: flex;
  align-items: center;
}

.filter-operator-dropdown {
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 0.875rem;
  padding: 0.375rem 0.5rem;
  border: 1px solid #dee2e6;
  border-radius: 0 0.25rem 0.25rem 0;
  background-color: #f8f9fa;
  min-width: 40px;
  cursor: pointer;
  user-select: none;
}

.filter-operator-dropdown:hover {
  background-color: #e9ecef;
  border-color: #adb5bd;
}

.filter-operator-display {
  font-weight: 500;
  color: #495057;
  min-height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.filter-operator-arrow {
  font-size: 0.6rem;
  color: #6c757d;
  margin-left: 0.25rem;
  transition: transform 0.2s ease;
}

.filter-operator-dropdown.show .filter-operator-arrow {
  transform: rotate(180deg);
}

.filter-operator-menu {
  position: absolute;
  top: 100%;
  right: 0;
  background: white;
  border: 1px solid #dee2e6;
  border-radius: 0.25rem;
  box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15);
  z-index: 1000;
  min-width: 200px;
  max-height: 200px;
  overflow-y: auto;
}

.filter-operator-option {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0.5rem 0.75rem;
  cursor: pointer;
  font-size: 0.8rem;
  border-bottom: 1px solid #f8f9fa;
}

.filter-operator-option:hover {
  background-color: #f8f9fa;
}

.filter-operator-option.active {
  background-color: #e3f2fd;
  color: #1976d2;
}

.filter-operator-option:last-child {
  border-bottom: none;
}

.operator-label {
  font-weight: 500;
}

.operator-symbol {
  font-weight: 600;
  color: #6c757d;
  margin-left: 0.5rem;
}

.filter-empty {
  font-size: 0.875rem;
  color: #6c757d;
  text-align: center;
  padding: 0.375rem;
  background-color: #f8f9fa;
  border-radius: 0.25rem;
  border: 1px solid #dee2e6;
}
</style>

